
import {
    SET_DISCOVERY_PROPERTIES,
    SET_LISTINGS,
    SET_PROPERTY_TYPE_IMAGE_URL,
    SET_PROPERTY_TYPES_PRICE,
    SET_DESTINATIONS_LISTINGS
} from '../actions/action-types';

export default function modules(state = {}, action) {
    switch (action.type) {
        case SET_LISTINGS:
            return {
                ...state,
                searchMessages: action.mapListingMessages
            };
        case SET_PROPERTY_TYPE_IMAGE_URL:
            return {
                ...state,
                propertyTypes: {
                    ...state.propertyTypes,
                    imagesUrls: action.payload
                }
            };
        case SET_PROPERTY_TYPES_PRICE:
            return {
                ...state,
                propertyTypes: {
                    ...state.propertyTypes,
                    propertyTypePrices: action.payload
                }
            };
        case SET_DISCOVERY_PROPERTIES:
            return {
                ...state,
                discoveryProperties: action.payload
            };
        case SET_DESTINATIONS_LISTINGS:
            return {
                ...state,
                destinations: state.destinations.map((destination) => ({
                    ...destination,
                    ...action.payload[destination.lbsId]
                }))
            };
        default:
            return state;
    }
}
